import DashboardChartTypeFilter from "./DashboardChartTypeFilter";

export default DashboardChartTypeFilter;
